// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { toValidClassName, translateFromPresentation, } from "@sequentech/ui-core";
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { getBallotStyleDefaultLanguageCode } from "../../services/defaultLanguageCode";
/**
 * Manages election class on <html>
 */
export var useElectionClassName = function (confirmationBallot) {
    var i18n = useTranslation().i18n;
    var extractElectionName = function (election) {
        var language = i18n.resolvedLanguage || i18n.language;
        var defaultLanguageCode = getBallotStyleDefaultLanguageCode(confirmationBallot === null || confirmationBallot === void 0 ? void 0 : confirmationBallot.election_config);
        return (translateFromPresentation(election.presentation, "alias", language) ||
            translateFromPresentation(election.presentation, "name", language) ||
            (defaultLanguageCode
                ? translateFromPresentation(election.presentation, "alias", defaultLanguageCode) ||
                    translateFromPresentation(election.presentation, "name", defaultLanguageCode)
                : undefined) ||
            election.id);
    };
    var electionClassName = useMemo(function () {
        if (!confirmationBallot || !confirmationBallot.election_config.election_presentation)
            return null;
        var election = {
            presentation: confirmationBallot.election_config.election_presentation,
            id: confirmationBallot.election_config.election_id,
        };
        return toValidClassName(extractElectionName(election));
    }, [extractElectionName, confirmationBallot]);
    useEffect(function () {
        if (!electionClassName)
            return;
        var appRoot = document.querySelector(".app-root");
        if (!appRoot)
            return;
        appRoot.classList.add(electionClassName);
        return function () {
            appRoot.classList.remove(electionClassName);
        };
    }, [electionClassName]);
};
